module.exports = __webpack_public_path__ + "static/media/mobiles.e5301165.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/mobiles.png
// module id = 267
// module chunks = 0